
import { getApiVersion } from './config.js'
import { makeGetRequest, makePostRequest } from './util.js'

const RELATIVE_PREFIX = 'routing_management'

function getPendingNotification(queryParams) {
  var filteredQueryParams = {}
  if (queryParams.studentFilter) filteredQueryParams.student = queryParams.studentFilter
  if (queryParams.partitionFilter) filteredQueryParams.partition = queryParams.partitionFilter
  if (queryParams.districtFilter) filteredQueryParams.district = queryParams.districtFilter
  if (queryParams.buildingFilter) filteredQueryParams.building = queryParams.buildingFilter
  if (queryParams.orderBy) filteredQueryParams.order_by = queryParams.orderBy
  if (queryParams.page) filteredQueryParams.page = queryParams.page

  return makeGetRequest(`${getApiVersion()}/${RELATIVE_PREFIX}/pending_notification`, filteredQueryParams)
}

function postPendingNotificationDelete(body) {
  return makePostRequest(`${getApiVersion()}/${RELATIVE_PREFIX}/pending_notification/delete`, body)
}

export {
  getPendingNotification,
  postPendingNotificationDelete,
}
